import React from "react";
import { Flex, Heading, Text, Box, Image } from "rebass";
import styled from "styled-components";
import Img from "react-image";

import Circle from "../../components/ui/Circle";
import Button from "../../components/ui/Button";
import segmentIcon from "../../img/segment-icon.svg";
import funnelExample from "../../img/funnel-example.jpg";

type Props = {
  siteMetadata: { appUrl: string }
};

const { Fragment } = React;

const IntroPart1 = (props: Props) => (
  <Flex pt={[0, 0, "140px", "240px"]} wrap>
    <Box
      w={[1, 1, "60%"]}
      mb={[4, 4, 6]}
      pl={[0, 0, 0, 5]}
      pt={["70px"]}
      className="relative"
    >
      <Image
        src={segmentIcon}
        alt="Segment your followers icon"
        mb={[4]}
        is={Img}
      />

      <Heading
        color="support2"
        className="font-light relative"
        is="h4"
        f={[3, 4, "26px"]}
        mb={[3]}
      >
        <Circle style={{ position: "absolute", left: "-25px", top: "-15px" }} />
        Funnel your followers
      </Heading>

      <Text color="support1" f="15px" mb={[4]} w={["70%", "70%", "80%", "70%"]}>
        Segment your users based on where they are in the sales funnel.
        It&apos;s completely automated, so you just need to set and forget.
      </Text>

      <Section1Circles>
        <Section1Circle1 r={14.5} />
        <Section1Circle2 r={20.5} />
        <Section1Circle3 r={38} />
      </Section1Circles>

      <Button is="a" href={props.siteMetadata.appUrl}>
        GET STARTED FOR FREE
      </Button>
    </Box>

    <Box w={[1, 1, "40%"]} mb={["75px", null, "130px"]}>
      <Part1Image src={funnelExample} alt="funnel example" is={Img} />
    </Box>
  </Flex>
);

export default IntroPart1;

// Styled Components
const Section1Circles = styled.div`
  display: none;
  opacity: 0.8;
  position: absolute;
  right: 150px;
  top: 200px;

  @media (min-width: 56em) {
    display: block;
  }
`;

const Section1Circle1 = styled(Circle)`
  left: -25px;
  position: absolute;
  top: 50px;
  }
`;

const Section1Circle2 = styled(Circle)`
  left: 15px;
  position: absolute;
  top: 60px;
`;

const Section1Circle3 = styled(Circle)`
  left: 65px;
  position: absolute;
  top: 70px;
`;

const Part1Image = styled(Image)`
  width: 100%;

  @media (min-width: 48em) {
    max-width: 405px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Intro/IntroPart1.jsx